











import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency6AccountUserProfilePicture from './digital-currency-6-account-user-profile-picture.vue'
import DigitalCurrency7AccountBalanceNumberWithIcon from './digital-currency-7-account-balance-number-with-icon.vue'


@Component({
  components: {
    DigitalCurrency6AccountUserProfilePicture,
    DigitalCurrency7AccountBalanceNumberWithIcon
  }
})
class DigitalCurrency5AccountThumbnail extends Vue {
  @Prop({ default: '' }) name?: string
  @Prop({ default: '' }) name2?: string
  @Prop({ default: '' }) imageSrcUrl?: string
  @Prop({ default: 120 }) imageSize?: number
  @Prop({ default: 0 }) currencyAmount?: number
  @Prop({ default: false }) showCurrencyAmount?: boolean
}
export default DigitalCurrency5AccountThumbnail
